import React from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import i18n from 'i18n';
import {FormikProps} from 'formik';
import {EvaluationTask} from '@/views/admin/channel/types';

type Props = {
    formik: FormikProps<EvaluationTask>;
};

const EvaluationTaskServiceFeaturesFormFields: React.FC<Props> = React.memo(({formik}) => {
    return (
        <>
            <Row>
                <Col xs={12}>
                    <Form.Group className="mb-3" controlId="params.url" >
                        <Form.Label>{i18n.t('jt_service_url.text')}</Form.Label>
                        <Form.Control
                            type="text"
                            name="params.url"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.params.url || ''}
                            isInvalid={formik.touched.params?.url && !!formik.errors.params?.url}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.params?.url}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row >
        </>
    );
});

export default EvaluationTaskServiceFeaturesFormFields; 